import React from 'react';
import { TextField, InputLabel, IconButton, FormHelperText, Box } from '@mui/material';
import { FieldArray, FormikErrors, FormikTouched } from 'formik';
import { ClientData } from '../../../core/api/clients/ClientModel';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

interface ContactDetailsSectionProps {
  values: Partial<ClientData>;
  errors: FormikErrors<ClientData>;
  touched: FormikTouched<ClientData>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
  className: string;
  emailInputClassName: string;
  emailsContainerClassName: string;
}

export const ContactDetailsSection: React.FC<ContactDetailsSectionProps> = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  className,
  emailInputClassName,
  emailsContainerClassName,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '12px',
        '& .MuiInputBase-root': { width: '100%' },
        '& .MuiOutlinedInput-root': { width: '100%' },
        '& .MuiFormControl-root': { width: '100%', minHeight: '56px' }
      }}
    >
      <TextField
        className={className}
        error={Boolean(errors.addressee)}
        id="addressee"
        type="text"
        name="addressee"
        label="Įmonės adresatas"
        onChange={handleChange}
        helperText={errors.addressee}
        fullWidth
        value={values.addressee}
        onBlur={handleBlur}
        variant="outlined"
      />
      
      <TextField
        className={className}
        error={Boolean(errors.companyPhone)}
        id="companyPhone"
        type="text"
        name="companyPhone"
        label="Telefono numeris"
        onChange={handleChange}
        helperText={errors.companyPhone}
        fullWidth
        value={values.companyPhone}
        onBlur={handleBlur}
        variant="outlined"
      />
      
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        width: '100%'
      }}>
        <InputLabel id="emailsLabel-label" className={className} sx={{ mb: 1, pl: 1 }}>
          El. pašto adresai
        </InputLabel>
        
        <Box 
          className={emailsContainerClassName}
          sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            width: '100%'
          }}
        >
          <FieldArray
            name="emails"
            render={(arrayHelpers) => (
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                width: '100%'
              }}>
                {values.emails?.map((email, index) => (
                  <Box 
                    key={index} 
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      width: '100%'
                    }}
                  >
                    <TextField
                      className={emailInputClassName}
                      size="small"
                      id={`emails[${index}]`}
                      type="text"
                      name={`emails[${index}]`}
                      error={errors.emails && touched.emails ? true : false}
                      fullWidth
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={email}
                      sx={{ flex: 1 }}
                    />
                    <IconButton
                      color="secondary"
                      aria-label="Išimti adresą"
                      component="span"
                      onClick={() => arrayHelpers.remove(index)}
                      size="small"
                      sx={{ ml: 1 }}
                    >
                      <RemoveIcon />
                    </IconButton>
                  </Box>
                ))}
                <Box>
                  <IconButton
                    color="primary"
                    aria-label="Pridėti adresą"
                    component="span"
                    onClick={() => arrayHelpers.push("")}
                    size="medium">
                    <AddIcon />
                  </IconButton>
                  {errors.emails && touched.emails && (
                    <FormHelperText error>{errors.emails}</FormHelperText>
                  )}
                </Box>
              </Box>
            )}
          />
        </Box>
      </Box>
    </Box>
  );
}; 